module.exports = __webpack_public_path__ + "img/logo-upload-img.3c668e02.svg";